import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import forwardArrow from '../../../assets/icons/forward.svg';
import Card from './card';
import whiteSchedule from '../../../assets/icons/whiteSchedule.svg';
import { useEffect } from 'react';
import oldHistoryService from '../../../api/services/oldHistoryService';
import * as moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setOldHistory } from '../../common/components/sidebar/sidebar.actions';
import { useDispatch, useSelector } from 'react-redux';
import { playSong, setOldHistoryDate, setOldHistoryDateOption } from '../../common/actions/common.actions';
import { BiSolidCalendar } from "react-icons/bi";
import { IoIosArrowBack } from "react-icons/io";

const OldHistories = ({ setIsLoading }) => {
    const dispatch = useDispatch();
    const [oldHistories, setOldHistories] = useState([]);
    const { oldHistoryDate, oldHistoryDateOption } = useSelector((state) => state.common);
    console.log({ oldHistoryDate, oldHistoryDateOption })
    const initialStoredDate = oldHistoryDate ? new Date(oldHistoryDate) : new Date();
    const [selectedDate, setSelectedDate] = useState(initialStoredDate);
    const [histories, setHistories] = useState(true);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleBackClick = () => {
        const newDate = new Date();
        dispatch(setOldHistoryDate(newDate.toISOString()));
        handleSongClick();
        navigate('/dashboard');
    };

    useEffect(() => {
        const handleEvent = (e) => {
            e.preventDefault();
            const newDate = new Date();
            dispatch(setOldHistoryDate(newDate.toISOString()));
        };
        window.addEventListener('popstate', handleEvent);
        return () => {
            window.removeEventListener('popstate', handleEvent);
        }
    }, []);

    useEffect(() => {
        setIsLoading(true);
        let startDate, endDate;
        if (oldHistoryDateOption === 'choose') {
            startDate = moment(oldHistoryDate).format('YYYY-MM-DD');
            endDate = moment(oldHistoryDate).format('YYYY-MM-DD');
        } else if (oldHistoryDateOption === 'today') {
            startDate = moment(new Date()).format('YYYY-MM-DD');
            endDate = moment(new Date()).format('YYYY-MM-DD');
            // setSelectedDate(startDate);
        } else if (oldHistoryDateOption === 'yesterday') {
            startDate = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
            endDate = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
        } else {
            startDate = moment(selectedDate).format('YYYY-MM-DD');
            endDate = moment(selectedDate).format('YYYY-MM-DD');
        }
        oldHistoryService
            .bettingOldHistory({
                startDate: startDate,
                endDate: endDate,
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.message === 'NO Data Found!!') {
                    // Handle the case where no data is found
                    setHistories(false);
                } else if (data) {
                    // const filteredData = data.filter((history) =>
                    //   moment(history.createdDate).isSame(endDate, 'day'),
                    // );
                    setOldHistories(data);
                    setHistories(data.length > 0); // Check if there are transactions
                } else {
                    setHistories(false); // No transactions available
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                console.error('API request error:', err);
            });
    }, [navigate, setIsLoading, selectedDate, oldHistoryDateOption]);

    const handleDateChange = (date) => {
        dispatch(setOldHistoryDate(date.toISOString()));
        dispatch(setOldHistoryDateOption('choose'));
        setSelectedDate(date);
    };


    const handleSelectedOptionChange = (value) => {
        dispatch(setOldHistoryDateOption(value));
    }

    return (
        <div className="w-full flex flex-col h-[100dvh] bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative overflow-hidden">
            {/* Football Background Animation */}
            <div className="absolute inset-0 pointer-events-none opacity-20">
                {[...Array(6)].map((_, i) => (
                    <div
                        key={`history-line-${i}`}
                        className="absolute w-full h-px bg-[#228B22] opacity-30"
                        style={{ top: `${(i + 1) * 16.66}%` }}
                    />
                ))}

                {/* Floating Football and Money Icons */}
                {[...Array(8)].map((_, i) => (
                    <div
                        key={`history-icon-${i}`}
                        className="absolute text-lg opacity-10"
                        style={{
                            left: `${10 + i * 12}%`,
                            top: `${20 + (i % 3) * 25}%`,
                            color: i % 3 === 0 ? '#228B22' : i % 3 === 1 ? '#FFD700' : '#1E90FF',
                            animation: `floatingHistoryIcon 8s ease-in-out infinite ${i * 1.5}s`
                        }}
                    >
                        {i % 3 === 0 ? '⚽' : i % 3 === 1 ? '💰' : '$'}
                    </div>
                ))}
            </div>

            {/* CSS Animation */}
            <style jsx>{`
                @keyframes floatingHistoryIcon {
                    0%, 100% { transform: translateY(0px) scale(1); }
                    50% { transform: translateY(-15px) scale(1.1); }
                }
            `}</style>

            {/* Header */}
            <div className="relative z-50 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-4 px-4 shadow-lg">
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <button
                            className="w-10 h-10 mr-4 flex justify-center items-center text-white hover:bg-white/20 rounded-xl transition-all duration-200"
                            onClick={handleBackClick}
                        >
                            <IoIosArrowBack size={25} />
                        </button>
                        <div>
                            <h3 className="text-white font-bold text-xl">{t('oldHistories')}</h3>
                            <p className="text-emerald-100 text-xs font-medium">Betting History</p>
                        </div>
                    </div>
                    <div className="flex justify-center items-center">
                        <label htmlFor="oldHistoryDate" className="w-10 h-10 flex items-center justify-center text-white hover:bg-white/20 rounded-xl transition-all duration-200 cursor-pointer">
                            <BiSolidCalendar size={24} />
                        </label>
                        <DatePicker
                            id="oldHistoryDate"
                            selected={selectedDate || new Date()}
                            onChange={handleDateChange}
                            dateFormat="yyyy-MM-dd"
                            withPortal
                            closeOnSelect={true}
                            className="w-2 h-9 hidden border-none bg-inherit text-white focus:outline-none text-transparent"
                        />
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="relative z-20 flex-1 overflow-auto bg-white/50">
                {/* Filter Section */}
                {/* <div className="flex justify-end pt-4 pr-4">
                    <div className="relative">
                        <select
                            className="block bg-gradient-to-r from-[#228B22] to-emerald-600 text-white text-sm appearance-none shadow-lg w-full py-3 px-6 pr-10 rounded-2xl font-bold font-myanmarSansPro leading-tight focus:ring-2 focus:ring-[#FFD700] focus:outline-none border border-[#228B22]/20"
                            value={oldHistoryDateOption}
                            onChange={(e) => handleSelectedOptionChange(e.target.value)}
                        >
                            <option value="choose" className='text-black'>Choose Date</option>
                            <option value="today" className='text-black'>{t('today')}</option>
                            <option value="yesterday" className='text-black'>{t('yesterday')}</option>
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                </div> */}

                {/* History Cards */}
                <div className="p-4">
                    <div className={`z-20 w-full ${histories ? 'space-y-4' : 'contents'}`}>
                        {histories ? (
                            oldHistories?.map((data, index) => (
                                <Link
                                    key={index}
                                    to={`/old-matches/${data?.gamblingId}`}
                                    onClick={() => {
                                        dispatch(setOldHistory(data));
                                        handleSongClick();
                                    }}
                                >
                                    <Card data={data} />
                                </Link>
                            ))
                        ) : (
                            <div className="flex flex-1 justify-center items-center h-64">
                                <div className="text-center bg-white/80 rounded-2xl p-8 border border-[#228B22]/20 shadow-lg">
                                    <div className="w-16 h-16 bg-[#228B22]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <span className="text-2xl">📊</span>
                                    </div>
                                    <p className="text-gray-600 font-medium">{t('noData')}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OldHistories;
